import React from 'react';
import { useSelector } from 'react-redux';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Typography,
    withStyles,
} from '@material-ui/core';
import { getOwnersProperties } from '../../stores/dashboard/selectors';
import OwnerDashboardChartRow from './OwnerDashboardChartRow';
import OwnerDashboardChartTotalsRow from './OwnerDashboardChartTotalsRow';
import styles from './styles';

const OwnerDashboardChartView = (props) => {
    const properties = useSelector(getOwnersProperties);

    return (
        <>
            <Typography
                variant="h6"
                className={props.classes.chartViewTitleStyle}
            >
                Chart View
            </Typography>
            <Paper style={{ marginTop: 32, padding: 16 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">
                                <Typography
                                    className={props.classes.headerTextStyle}
                                    align="left"
                                >
                                    Location
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography
                                    className={props.classes.headerTextStyle}
                                    align="center"
                                >
                                    Gross Bookings
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography
                                    className={props.classes.headerTextStyle}
                                    align="center"
                                >
                                    Income
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography
                                    className={props.classes.headerTextStyle}
                                    align="center"
                                >
                                    Stripe Payments
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography
                                    className={props.classes.headerTextStyle}
                                    align="center"
                                >
                                    In-Store Cash Sales
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography
                                    className={props.classes.headerTextStyle}
                                    align="center"
                                >
                                    # of Fuel Comps
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {properties.map((property, idx) => (
                            <OwnerDashboardChartRow
                                key={property.propertyId || property.id}
                                property={property}
                                index={idx}
                            />
                        ))}
                        {/* Totals row */}
                        <OwnerDashboardChartTotalsRow />
                    </TableBody>
                </Table>
            </Paper>
        </>
    );
};

export default withStyles(styles)(OwnerDashboardChartView);
